import { Form, Input, Button, Select } from "antd";
import {
  SearchOutlined,
  ReloadOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import useAddSupplier from "../hooks/useAddSupplier";
import SupplierSelect from "../../../components/BaseInfoSelects/SupplierSelect";
import AuthComponent from "../../../components/AuthComponent";
export default function SupplierFiltersForm({
  form,
  onFormDataChange,
  initialValues,
  onAddSupplierSuccess,
  onAddSupplierFail,
}) {
  const [_form] = Form.useForm(form);
  const { addSupplier } = useAddSupplier();
  const addSupplierFinish = () => {
    addSupplier()
      .then((res) => {
        if (typeof onAddSupplierSuccess === "function") {
          onAddSupplierSuccess(res);
        }
        console.log("addSupplier-success", res);
      })
      .catch((e) => {
        if (typeof onAddSupplierFail === "function") {
          onAddSupplierFail(e);
        }
      });
  };
  const OnOptionsLoad = () => {};
  return (
    <Form
      form={_form}
      layout="inline"
      onFinish={onFormDataChange}
      // onReset={onFormDataChange}
      initialValues={initialValues}
    >
      <Form.Item name="supplierId" label="供应商">
        <SupplierSelect OnOptionsLoad={OnOptionsLoad} />
      </Form.Item>
      <Form.Item name="contactName" label="联系人">
        <Input style={{ width: 200 }} placeholder="请输入内容" />
      </Form.Item>
      <Form.Item name="validity" label="状态">
        <Select placeholder="不限" allowClear style={{ width: 200 }}>
          <Select.Option value={1}>已启用</Select.Option>
          <Select.Option value={0}>已禁用</Select.Option>
          <Select.Option value={-1}>已删除</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item>
        <AuthComponent authKey="/supplier/page">
          <Button
            htmlType="submit"
            ghost
            type="primary"
            icon={<SearchOutlined />}
          >
            搜索
          </Button>
        </AuthComponent>
      </Form.Item>
      <Form.Item>
        <AuthComponent authKey="/supplier/page">
          <Button
            htmlType="reset"
            ghost
            type="primary"
            icon={<ReloadOutlined />}
          >
            重置
          </Button>
        </AuthComponent>
      </Form.Item>
      <Form.Item>
        <AuthComponent authKey="/supplier/create">
          <Button
            type="primary"
            htmlType="button"
            icon={<PlusOutlined />}
            onClick={addSupplierFinish}
          >
            创建供应商
          </Button>
        </AuthComponent>
      </Form.Item>
    </Form>
  );
}
